import { render, staticRenderFns } from "./shuidianInfo.vue?vue&type=template&id=22323255"
import script from "./shuidianInfo.vue?vue&type=script&lang=js"
export * from "./shuidianInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports